<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.31818 3H3.68182C3.30526 3 3 3.30526 3 3.68182V8.31818C3 8.69474 3.30526 9 3.68182 9H8.31818C8.69474 9 9 8.69474 9 8.31818V3.68182C9 3.30526 8.69474 3 8.31818 3Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M17.3182 3H12.6818C12.3053 3 12 3.30526 12 3.68182V8.31818C12 8.69474 12.3053 9 12.6818 9H17.3182C17.6947 9 18 8.69474 18 8.31818V3.68182C18 3.30526 17.6947 3 17.3182 3Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M26.3182 3H21.6818C21.3053 3 21 3.30526 21 3.68182V8.31818C21 8.69474 21.3053 9 21.6818 9H26.3182C26.6947 9 27 8.69474 27 8.31818V3.68182C27 3.30526 26.6947 3 26.3182 3Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M8.31818 12H3.68182C3.30526 12 3 12.3053 3 12.6818V17.3182C3 17.6947 3.30526 18 3.68182 18H8.31818C8.69474 18 9 17.6947 9 17.3182V12.6818C9 12.3053 8.69474 12 8.31818 12Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M8.31818 21H3.68182C3.30526 21 3 21.3053 3 21.6818V26.3182C3 26.6947 3.30526 27 3.68182 27H8.31818C8.69474 27 9 26.6947 9 26.3182V21.6818C9 21.3053 8.69474 21 8.31818 21Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M17.3182 12H12.6818C12.3053 12 12 12.3053 12 12.6818V17.3182C12 17.6947 12.3053 18 12.6818 18H17.3182C17.6947 18 18 17.6947 18 17.3182V12.6818C18 12.3053 17.6947 12 17.3182 12Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M17.3182 21H12.6818C12.3053 21 12 21.3053 12 21.6818V26.3182C12 26.6947 12.3053 27 12.6818 27H17.3182C17.6947 27 18 26.6947 18 26.3182V21.6818C18 21.3053 17.6947 21 17.3182 21Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M26.3182 12H21.6818C21.3053 12 21 12.3053 21 12.6818V17.3182C21 17.6947 21.3053 18 21.6818 18H26.3182C26.6947 18 27 17.6947 27 17.3182V12.6818C27 12.3053 26.6947 12 26.3182 12Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M26.3182 21H21.6818C21.3053 21 21 21.3053 21 21.6818V26.3182C21 26.6947 21.3053 27 21.6818 27H26.3182C26.6947 27 27 26.6947 27 26.3182V21.6818C27 21.3053 26.6947 21 26.3182 21Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconGrid2',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>